import { createFileRoute } from "@tanstack/react-router";
import { EntityFormPage } from "@/components/entity-page/EntityFormPage";
import CreateProviderForm from "@/components/CreateProviderForm";

export const Route = createFileRoute("/dashboard/settings/providers/new")({
  component: CreateProviderPage,
});

function CreateProviderPage() {
  return <CreateProviderPageComponent />;
}

// Exported for testing
export function CreateProviderPageComponent() {
  return (
    <EntityFormPage
      title="Create Provider"
      description="Add a new provider to the catalog."
      backHref="/dashboard/settings/providers"
    >
      <CreateProviderForm />
    </EntityFormPage>
  );
}
